import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { MobileMicPage } from './components/MobileMicPage';
import {
  handleGoogleAuthReturn,
  isGoogleAuthReturnPath,
} from './utils/googleAuthReturn';
import './styles/tokens.css';
import './styles/global.css';
import './styles/hover-glow.css';

/**
 * Atalho de DEV/QA: ?reset na URL limpa flags de onboarding/legal/cookies
 * pra testar fluxo da primeira vez sem precisar abrir DevTools.
 */
(function maybeResetFromQuery() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('reset')) {
    try {
      localStorage.removeItem('drpera-ia-onboarding-done');
      localStorage.removeItem('drpera-legal-accepted-v1');
      localStorage.removeItem('drpera-legal-accepted-v1-timestamp');
      localStorage.removeItem('drpera-cookie-consent');
      // eslint-disable-next-line no-console
      console.log('[Dr. Pera] Flags resetadas: onboarding, legal, cookies');
    } catch {
      // silencioso
    }
    // Remove ?reset da URL pra não disparar de novo em recargas
    const url = new URL(window.location.href);
    url.searchParams.delete('reset');
    window.history.replaceState({}, '', url.toString());
  }
})();

// Monta a aplicação na raiz
const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root não encontrado no DOM');

/**
 * Roteamento pathname-based (sem react-router pra manter bundle enxuto).
 * `/mic/:token` é a página mobile do voice (Fase Voice S3) — abre quando
 * o médico escaneia o QR code gerado no PC. Token = 22 chars base32
 * Crockford (gerado em createPairingToken no backend).
 *
 * Qualquer outra rota → App principal (login + chat).
 */
const pathname = window.location.pathname;
const micMatch = pathname.match(/^\/mic\/([A-Z2-7]{22})$/);

/**
 * Retorno do login Google (`/auth/google#token=...` ou `#error=...`) —
 * processa o fragment e limpa a URL ANTES do App montar: o useAuth lê o
 * JWT do localStorage no mount, então o médico já entra logado. Erro fica
 * em sessionStorage (one-shot) pro App mostrar mensagem amigável.
 * A rota serve o index.html via SPA fallback (_redirects: /* → 200).
 */
if (isGoogleAuthReturnPath(pathname)) {
  handleGoogleAuthReturn();
}

if (micMatch !== null) {
  const token = micMatch[1] as string;
  createRoot(root).render(
    <React.StrictMode>
      <MobileMicPage token={token} />
    </React.StrictMode>,
  );
} else {
  createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
